// Recovered compiled webpack factory 4300. Edit this function expression; run npm run build.
(e) => {
  (() => {
    "use strict";
    "undefined" != typeof __nccwpck_require__ && (__nccwpck_require__.ab = "//");
    var t = {};
    ((() => {
      ((t.parse = function (t, r) {
        if ("string" != typeof t) throw TypeError("argument str must be a string");
        for (var a = {}, o = t.split(n), i = (r || {}).decode || e, s = 0; s < o.length; s++) {
          var l = o[s],
            u = l.indexOf("=");
          if (!(u < 0)) {
            var c = l.substr(0, u).trim(),
              f = l.substr(++u, l.length).trim();
            ('"' == f[0] && (f = f.slice(1, -1)),
              void 0 == a[c] &&
                (a[c] = (function (e, t) {
                  try {
                    return t(e);
                  } catch (t) {
                    return e;
                  }
                })(f, i)));
          }
        }
        return a;
      }),
        (t.serialize = function (e, t, n) {
          var o = n || {},
            i = o.encode || r;
          if ("function" != typeof i) throw TypeError("option encode is invalid");
          if (!a.test(e)) throw TypeError("argument name is invalid");
          var s = i(t);
          if (s && !a.test(s)) throw TypeError("argument val is invalid");
          var l = e + "=" + s;
          if (null != o.maxAge) {
            var u = o.maxAge - 0;
            if (isNaN(u) || !isFinite(u)) throw TypeError("option maxAge is invalid");
            l += "; Max-Age=" + Math.floor(u);
          }
          if (o.domain) {
            if (!a.test(o.domain)) throw TypeError("option domain is invalid");
            l += "; Domain=" + o.domain;
          }
          if (o.path) {
            if (!a.test(o.path)) throw TypeError("option path is invalid");
            l += "; Path=" + o.path;
          }
          if (o.expires) {
            if ("function" != typeof o.expires.toUTCString)
              throw TypeError("option expires is invalid");
            l += "; Expires=" + o.expires.toUTCString();
          }
          if ((o.httpOnly && (l += "; HttpOnly"), o.secure && (l += "; Secure"), o.sameSite))
            switch ("string" == typeof o.sameSite ? o.sameSite.toLowerCase() : o.sameSite) {
              case !0:
              case "strict":
                l += "; SameSite=Strict";
                break;
              case "lax":
                l += "; SameSite=Lax";
                break;
              case "none":
                l += "; SameSite=None";
                break;
              default:
                throw TypeError("option sameSite is invalid");
            }
          return l;
        }));
      var e = decodeURIComponent,
        r = encodeURIComponent,
        n = /; */,
        a = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;
    })(),
      (e.exports = t));
  })();
}
